var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContactSupport',{staticClass:"py-25 sm:px-50",on:{"cancel":function($event){return _vm.$emit('close')}}},[_c('HMButton',{staticClass:"w-full mt-10 border",attrs:{"color":"white"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" "+_vm._s(_vm.$t('contact_support.cancel'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }